module.exports = __webpack_public_path__ + "img/online.76bf45c.png";